import React from 'react'
import styled from 'styled-components'
import { screen } from '../../../utils/index'

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  ${ screen('md') } {
    grid-gap: 30px;
    grid-template-columns: repeat(2, 1fr);
  }

  ${ screen('lg') } {
    grid-gap: 75px;
  }
`

const TwoUp = ({ children, noGaps }) => (
  <GridWrap style={ noGaps ? { gridGap: '0px' } : {} }>
    { children.map((child, i) => (
      <div key={ `two-up-item-${ i }`}>{ child }</div>
    )) }
  </GridWrap>
)

export default TwoUp
